import { BwDownloadLine } from "@/components/ui/icons";
import type { LightBoxAttachment } from "@/components/ui/lightbox/light-box-attachment";
import { resolveDownloadUrl } from "@/components/ui/lightbox/utils";
import { env } from "@/env";
import type { AttachmentAction } from "./attachment-menu";

/**
 * The standard "Download" item for a tile's "…" menu. Media-v3 files go through the
 * media service's download route, legacy ones through the CDN's `?download=true`; both
 * answer as an attachment. `null` when the file has no address yet.
 */
export function downloadAttachmentAction(
  file: Pick<LightBoxAttachment, "id" | "contentUri" | "originalContentUri">,
): AttachmentAction | null {
  const href = resolveDownloadUrl(file, {
    mediaServiceUrl: env.PUBLIC_MEDIA_SERVICE_URL,
  });
  if (!href) return null;
  return { key: "download", label: "Download", icon: BwDownloadLine, href };
}
